import React, { Fragment } from "react";
import styled from "styled-components";
import ProfileIntroSection from "../components/ProfileIntroSection";
import ProfileList from "../components/ProfileList";
import ProfileListItem from "../components/ProfileListItem";
import EventListItem from "../components/EventListItem";
import Head from "../components/Head";
import { media } from "../style/constants";
import { META } from "../utils/constants";
import { ContentWrapper } from "../style/shared";

const ListsSection = styled.section`
  ${media.sm`
    
  `}
`;

const ClientsList = styled(ProfileList)`
  ul {
    display: grid;
    grid-template-columns: max-content max-content max-content;
    grid-template-rows: repeat(6, 1fr);
    grid-auto-flow: column;
    grid-column-gap: 5rem;
    ${media.sm`
      grid-column-gap: 3rem;
    `}

    ${media.sm`
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: auto;
      grid-auto-flow: unset;
      grid-column-gap: 0;
    `}
  }
`;

export default ({ data }) => {
  const { clients, events, mentions, articles } = data;

  return (
    <ContentWrapper>
      <Head {...META.profile} image={META.common.image} />
      <ProfileIntroSection
        content={() => (
          <Fragment>
            <ListsSection>
              {mentions.edges.length > 0 && (
                <ProfileList
                  title={
                    "The song 'Silence' is now available as part of the Borrowed Verse album"
                  }
                  list={() =>
                    mentions.edges.map(({ mention }, i) => (
                      <ProfileListItem key={i} {...mention} />
                    ))
                  }
                />
              )}
            </ListsSection>
          </Fragment>
        )}
      />
    </ContentWrapper>
  );
};

export const profileQuery = graphql`
  query ProfileQuery {
    clients: allClientsJson {
      edges {
        client: node {
          name
        }
      }
    }
    events: allEventsJson {
      edges {
        event: node {
          year
          position
          company
        }
      }
    }
    mentions: allMentionsJson {
      edges {
        mention: node {
          name
          url
        }
      }
    }
    articles: allArticlesJson {
      edges {
        article: node {
          name
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/profile.js